global.bootstrapDatepicker = require('bootstrap-datepicker/dist/js/bootstrap-datepicker');

require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.ar.min');
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.tr.min');